export default [

    {
        path: '',
        name: 'material-de-apoio',
        redirect: { name: 'material-de-apoio-home' },
    },

    {
        path: 'home',
        name: 'material-de-apoio-home',
        component: () => import('@/aplicacao/modulos/material-de-apoio/_Home'),
        meta: { autenticacao: true, permissao: 'ROLE_MATERIAL_DE_APOIO' },
    },

    {
        path: 'marcas',
        name: 'material-de-apoio-marcas',
        component: () => import('@/aplicacao/modulos/banco-de-midias/BancoDeMarcas'),
        meta: { autenticacao: true, permissao: 'ROLE_MATERIAL_DE_APOIO' },
    },

    {
        path: ':slug',
        name: 'material-de-apoio-personalizadas',
        component: () => import('@/aplicacao/modulos/material-de-apoio/Personalizadas'),
        meta: { autenticacao: true, permissao: 'ROLE_MATERIAL_DE_APOIO' },
    },

]
